@use "ui/styles/colors";
@use "ui/styles/fontStyles";
@use "ui/styles/sizes";
@use "ui/styles/breakpoints";

.wrapper {
  background-color: colors.$white;
  border-bottom: 1px solid colors.$gray20;

  &.noBottomBorder {
    border-bottom: 0;
  }

  &.noHorizontalMargin {
    :global {
      .header-container {
        > div {
          padding-left: sizes.$s4;
          padding-right: sizes.$s4;

          @include breakpoints.mobile {
            padding-left: sizes.$s4;
            padding-right: sizes.$s4;
          }
        }
      }

      .builder-header {
        margin: 0;
      }
    }
  }

  :global {
    .header-container {
      > div {
        width: 100%;
        max-width: calc(sizes.$configMaxWidth + sizes.$configGutterWidth * 2);
        padding-left: sizes.$configGutterWidth;
        padding-right: sizes.$configGutterWidth;
        min-width: 0;
        margin: 0 auto;
      }
    }

    .header-row,
    .header-right,
    .header-left {
      display: flex;
      align-items: center;
    }

    .header-left {
      gap: sizes.$s6;
    }

    .builder-header {
      display: flex;
      flex-direction: column;
      justify-items: space-between;
      padding: sizes.$s5 0;
      margin: 0 sizes.$s7;
      gap: sizes.$s4;

      .header-row {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .header-text {
          @include fontStyles.h3-bold;
        }

        .subheader-text {
          @include fontStyles.subtitle-book;
          @include fontStyles.subdued;
          gap: sizes.$s4;

          &,
          div {
            display: flex;
            align-items: center;
          }
        }

        .header-right > * {
          margin-left: 12px;
        }
      }
    }
  }
}

.studioFileStatusWrapper {
  margin: 3px 8px 0 0;
}

.betaCapsuleWrapper {
  margin-top: 2px;
}
